import {Component, Input, ViewChild} from '@angular/core';
import {ReportResponse} from '../../../domain/report/report-response.model';
import {KnMainTableComponent} from './kn-main-table.component';

@Component({
  selector: 'cm-widget-main-table',
  template: `
    <cm-widget [expanded]="true">
      <cm-widget-title>
        Main table view
      </cm-widget-title>
      <cm-widget-header-center>
        <span *ngIf="table.filter.filterActive()">
          <span *ngIf="table.filter.name"><strong>Name</strong> {{table.filter.name}}</span>
          <span *ngIf="table.filter.name && table.filter.includeLowImpsAdUnits">/</span>
          <span *ngIf="table.filter.includeLowImpsAdUnits"><strong>All ad units</strong> </span>
          <a (click)="table.filter.reset()">clear filters</a>
        </span>
      </cm-widget-header-center>
      <cm-widget-actions class="d-flex align-items-center">
        
        <button mat-icon-button color="primary"
                [hidden]="loading"
                (click)="table.exportCsv()"
                class="d-none d-md-block mr-2"
                matTooltip="Export">
          <i class="fas fa-download" aria-hidden="true"></i>
        </button>
        <cm-mat-table-col-vis [columns]="table.columns" (change)="table.visibleColumns=$event" header="Columns">
        </cm-mat-table-col-vis>
        <cm-filters-dropdown #filterComponent header="Filters">
          <mat-form-field>
            <input matInput type="text" placeholder="Ad unit name" [formControl]="table.filter.adUnitNameFilterCtrl">
          </mat-form-field>

          <mat-checkbox [(ngModel)]="table.filter.includeLowImpsAdUnits" (change)="table.filterData()">
            Include units < 100 impressions?
          </mat-checkbox>

          <div class="dropdown-actions">
            <button mat-button color="primary" (click)="table.filter.reset()">Reset</button>
          </div>
        </cm-filters-dropdown>
      </cm-widget-actions>
      <cm-widget-content>
        <cm-kn-main-table #table [paginator]="paginator"></cm-kn-main-table>
      </cm-widget-content>
      <cm-widget-footer>
        <mat-paginator #paginator
                       [hidden]="loading"
                       [pageSize]="20"
                       [pageSizeOptions]="[10, 20, 50, 100, 200]">
        </mat-paginator>
      </cm-widget-footer>
    </cm-widget>
  `,
})
export class WidgetMainTableComponent {

  @ViewChild('table', { static: true }) table: KnMainTableComponent;

  @Input()
  loading = false;

  @Input()
  set data(data: ReportResponse) {
    this.table.renderData(data);
  }

}

